<div class="attention-sidebar-inner">
  <div class="attention-sidebar-brand p-16">
    <span class="f-s-14 f-w-600 text-uppercase text-muted">Atención</span>
  </div>
  <mat-nav-list class="attention-nav-list">
    @for (item of items; track item.route) {
      @if (isVisible(item)) {
        <a
          mat-list-item
          [routerLink]="item.route"
          [queryParams]="item.queryParams"
          [class.attention-nav-active]="isActive(item)"
          (click)="onLinkClick()"
        >
          @if (item.iconName) {
            <span matListItemIcon class="d-flex align-items-center">
              <i-tabler [name]="item.iconName" class="icon-20"></i-tabler>
            </span>
          }
          <span matListItemTitle class="f-s-13">{{ item.displayName }}</span>
        </a>
      }
    }
  </mat-nav-list>
</div>
